import { MenuItem } from "@mui/material";
import { Form } from "formik";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { getAllProviders } from "../../../../actions/providers";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import { FormikDateRangeInput, FormikDateRangeSearch } from "../../../commons/formik/formikDateRangeSearch";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextField from "../../../commons/formik/formikTextField";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledNovedadesSearchForm } from "../../../styled/connectivity";

const validationSchema = yup.object().shape({
  art: yup.string().required("El ART es obligatorio"),
  comportamientoNovedad: yup.string().nullable().required("El tipo de novedad es obligatorio"),
  providerId: yup.string().required("El proveedor es obligatorio"),
  startDate: yup
    .date()
    .required("La fecha desde es obligatoria")
    .typeError("Fecha inválida")
    .test(
      "startDate-before-endDate",
      "La fecha desde debe ser anterior a la fecha hasta",
      function (value) {
        const { endDate } = this.parent;
        if (value && endDate && new Date(value) > new Date(endDate)) {
          return false;
        }
        return true;
      },
    ),

  endDate: yup
    .date()
    .required("La fecha hasta es obligatoria")
    .typeError("Fecha inválida")
    .test(
      "endDate-after-startDate",
      "La fecha hasta debe ser posterior a la fecha desde",
      function (value) {
        const { startDate } = this.parent;
        if (value && startDate && new Date(value) < new Date(startDate)) {
          return false;
        }
        return true;
      },
    ),

});

const initialValues = {
  art: "",
  comportamientoNovedad: "",
  dni: "",
  providerId: "",
  startDate: null,
  endDate: null,
};

const tipoNovedades = [
  { id: "turno", nombre: "Turno" },
  { id: "iami", nombre: "IAMI" },
  { id: "fpt", nombre: "FPT" },
  { id: "fpa", nombre: "FPA" },
  { id: "am", nombre: "AM" },
  { id: "iet", nombre: "IET" },
];

const NovedadesPrestadorSearchForm = ({
  loading,
  arts,
  providers,
  handleSubmitSearch,
  model,
}) => {
  const dispatch = useDispatch();
  const handleChangeArt = useCallback((art) => {
    if (art) {
      dispatch(getAllProviders(art));
    }
  }, [dispatch]);

  return (
    <div>
      <StyledNovedadesSearchForm.StyledPaper>
        {!loading ? (
          <FormikForm
            initialValues={model ?? initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmitSearch}>
            {({ values }) => (
              <Form>

                <StyledNovedadesSearchForm.StyledInput>
                  <FormikSelect name="art" label="Art" variant="standard" callBack={handleChangeArt}>
                    {arts.map((art) => (
                      <MenuItem value={art.id} key={art.id}>
                        {art.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikSelect name="comportamientoNovedad" label="Tipo" variant="standard" >
                    {tipoNovedades.map((novedad) => (
                      <MenuItem value={novedad.id} key={novedad.id}>
                        {novedad.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikTextField name="dni" label="DNI" variant="standard" />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikAutocomplete
                    name="providerId"
                    label="Prestador"
                    variant="standard"
                    options={providers}
                    disabled={!values.art}
                  />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikDateRangeSearch />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikDateRangeInput
                    name="startDate"
                    label="Fecha Desde"
                  />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikDateRangeInput
                    name="endDate"
                    label="Fecha Hasta"
                  />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.ButtonContainer>
                  <StyledNovedadesSearchForm.StyledButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={loading}>
                    Buscar
                  </StyledNovedadesSearchForm.StyledButton>
                </StyledNovedadesSearchForm.ButtonContainer>
              </Form>
            )}
          </FormikForm>
        ) : (
          <CircularLoading />
        )}
      </StyledNovedadesSearchForm.StyledPaper>
    </div>
  );
};

export default NovedadesPrestadorSearchForm;
